module.exports = __webpack_public_path__ + "static/pedestal-efd7e1bfa1cb5cad5501a61f1b7ee70f.jpg";